import { GCInstant as platform } from 'src/lib/gcinstant';
import { createPersistentEmitter } from 'src/lib/Emitter';
import { System } from 'src/lib/utils';
import StateObserver from 'src/StateObserver';
import { levelActions } from './level.redux';

export function levelSystem(): System {
  const handleLevelUpdated = (payload: { current: number; xp: number }) => {
    StateObserver.dispatch(
      levelActions.setLevel({ id: platform.playerID, payload }),
    );
  };

  const levelEmitter = createPersistentEmitter(({ user }) => {
    return user.level;
  });

  return {
    start: () => {
      levelEmitter.addListener(handleLevelUpdated);
    },
    stop: () => {
      levelEmitter.removeListener(handleLevelUpdated);
    },
  };
}
